import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import SnForm from "@widgets/SnForm";

interface PopupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_PRD_BAS_REP_013_POP_01 = forwardRef(
  ({ selectedData, modalRef }: PopupProps, ref: React.Ref<any>) => {
    const formRef = useRef<any>(null);
    const [freeFormControls, setFreeFormControls] = useState<any[]>([]);
    const [formData, setFormData] = useState<any>({});

    useImperativeHandle(ref, () => ({
      getSelectedValue: () =>
        freeFormControls.length > 0
          ? (formRef.current?.getFormdata() ?? formData)
          : undefined,
    }));

    useEffect(() => {
      const fetchForm = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_PRD_BAS_REP_013_POP_01",
            {}
          );
          const freeform1 = rtn.form?.freeform1 ?? [];
          const defaults = {
            ...rtn.formData,
            ...rtn.form?.freeform1ControlData,
          };

          setFreeFormControls(freeform1);
          setFormData({ ...defaults, ...(selectedData ?? {}) });
        } catch (error: any) {
          await showDialog("error", error.message);
        }
      };

      fetchForm();
    }, [selectedData]);

    return (
      <div className="h-full text-sm">
        <SnForm
          ref={formRef}
          data={formData}
          controls={freeFormControls}
          popupRef={modalRef}
        />
      </div>
    );
  }
);

export default SN_PRD_BAS_REP_013_POP_01;
